import { colors } from '@mui/material';

export const ABSENCE_TYPES = {
  CP: { 
    label: 'CA', 
    color: colors.green[500],
    muiColor: 'success'
  },
  JTL: { 
    label: 'JTL', 
    color: colors.blue[500],
    muiColor: 'secondary'
  },
  MALADIE: { 
    label: 'Arrêt maladie', 
    color: colors.red[500],
    muiColor: 'error'
  },
  FORMATION: { 
    label: 'Formation', 
    color: colors.purple[500],
    muiColor: 'primary'
  },
  CM: { 
    label: 'CM', 
    color: colors.indigo[500],
    muiColor: 'primary'
  },
  TPS: { 
    label: 'Temps partiel', 
    color: colors.teal[500],
    muiColor: 'info'
  },
  RECUP: { 
    label: 'Récupération', 
    color: colors.cyan[500],
    muiColor: 'info'
  },
  RECUP_ASTREINTE: { 
    label: 'Récup astreinte', 
    color: colors.amber[600],
    muiColor: 'warning'
  },
  MEDICAL: { 
    label: 'Visite médicale', 
    color: colors.pink[500],
    muiColor: 'secondary'
  },
  AUTRE: { 
    label: 'Autre', 
    color: colors.orange[500],
    muiColor: 'warning'
  }
}; 